import { SyncSchedule } from '@app/core';
import { Document } from '@app/documents-base';
import { PhoneNumber } from "./phone-number";
import { PhoneNumberBlock } from './phone-number-block';
import { VoiceAccount } from './voice-account';

export class VoiceOption {
	/**
	 * @property
	 */
	public newNumbers: number = 0;

	/**
	 * @property
	 */
	public newNumberBlocks: number = 0;

	/**
	 * @property
	 */
	public voiceChannels: number = 2;

	/**
	 * @property
	 */
	public sourceCarrierId: string;

	/**
	 * @property
	 */
	public confirmationDate: Date;

	/**
	 * @property
	 */
	public newPhoneNumbers: PhoneNumber[] = [];

	/**
	 * @property
	 */
	public importPhoneNumbers: PhoneNumber[] = [];

	/**
	 * @property
	 */
	public newPhoneNumberBlocks: PhoneNumberBlock[] = [];

	/**
	 * @property
	 */
	public importPhoneNumberBlocks: PhoneNumberBlock[] = [];

	/**
	 * @property
	 */
	public portingDocument: Document;

	/**
	 * @property
	 */
	public portingOrderAvailable: boolean;

	/**
	 * @property
	 */
	public voiceAccount: VoiceAccount;

	/**
	 * @property
	 */
	public syncSchedules: SyncSchedule[];
}